<script lang="ts">
  import { onMount } from "svelte";
  import SearchHeader from "../../../components/SearchHeader.svelte";
  import { Table } from "../../../components/Table";
  import QualityLayout from "../../../layout/QualityLayout.svelte";
  import { qualityInternalMaintenanceDtoFields } from "../../../utils/TableFields/quality-internal-maintenance-dto.fields";

  import { filter, loading, records, pagination, initList, onCreate, onEdit, onDelete, onPageChange, search } from "./quality-internal-maintenance.store";

  onMount(initList);
</script>

<QualityLayout>
  <SearchHeader
    entitySingular="manutenzione interna"
    entityPlural="manutenzioni interne"
    numRecords={$pagination != null ? $pagination.totalRecords : 0}
    bind:searchValue={$filter.criteria.query}
    on:search={search}
  />

  <Table
    loading={$loading}
    fields={qualityInternalMaintenanceDtoFields}
    records={$records}
    pagination={$pagination}
    createEnabled={true}
    editEnabled={true}
    deleteEnabled={true}
    on:create={(_) => onCreate()}
    on:edit={(e) => onEdit(e.detail)}
    on:delete={(e) => onDelete(e.detail)}
    on:pageChange={(e) => onPageChange(e.detail)}
  />
</QualityLayout>
